import React, { useState } from 'react';
import { shape, number, string, func } from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { Button, AlertBanner } from '../../../common/components';
import GiftCard from './GiftCard';
import { useContent } from '../../../content/content-provider';
import { withConfig } from '../../../common/providers/configProvider';
import formatPrice from '../../../common/utils/format-price';

const styles = makeStyles(({ palette, spacing }: any) => ({
  useButton: {
    marginTop: spacing(11),
    marginBottom: '10px',
  },
  footer: {
    left: '0px',
    right: '0px',
    bottom: '0px',
    position: 'fixed',
    padding: `${spacing(6)}px ${spacing(5)}px ${spacing(7.5)}px ${spacing(5)}px`,
    backgroundColor: palette.background.default,
    boxShadow: `0px -1px 5px ${palette.background.contrastShadow}`,
    borderRadius: '10px 10px 0px 0px',
    zIndex: 2,
  },
  infoBanner: {
    marginTop: spacing(5),
  },
}));

const GiftCardBalance = ({
  config: {
    content: {
      common: { currency },
    },
  },
  giftCardQuery,
  useGiftCard,
}) => {
  const [content] = useContent();
  const classes = styles();
  const { totalBalance, cardNumber, redemptionAmount, remainingBalance } = giftCardQuery;

  const [isLoading, setIsLoading] = useState(false);

  const handleUseGiftCard = () => {
    // Not a hook despite the name!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useGiftCard(cardNumber);
    setIsLoading(true);
  };

  return (
    <>
      <GiftCard totalBalance={totalBalance} cardNumber={cardNumber} currency={currency} />
      <AlertBanner className={classes.infoBanner} variant="info" dataTestid="remainingBalance">
        {content.giftCard.remainingBalance.replace(
          '{string}',
          formatPrice(remainingBalance, currency)
        )}
      </AlertBanner>
      <div className={classes.footer}>
        <Button onClick={handleUseGiftCard} isLoading={isLoading}>
          {content.giftCard.useButton}
          {` ${formatPrice(redemptionAmount, currency)}`}
        </Button>
      </div>
    </>
  );
};

GiftCardBalance.propTypes = {
  config: shape({
    content: shape({
      common: shape({
        currency: string,
      }),
    }),
  }).isRequired,
  giftCardQuery: shape({
    redemptionAmount: number,
    totalBalance: number,
    remainingBalance: number,
    cardNumber: string,
  }).isRequired,
  useGiftCard: func.isRequired,
};

export default withConfig(GiftCardBalance);
